/* eslint-disable */
import { OrderProductDto } from '../dto/order-product-dto';

export interface OrderDto {
  creationDate: Date;
  price: number;
  status?: string | null;
  products: OrderProductDto[];
}

export const fixOrderDtoFromJson = (dto?: OrderDto | null): void => {
  if (!dto) {
    return;
  }
  dto.creationDate = dto.creationDate && new Date(dto.creationDate);
};

export const fixOrderDtoToJson = (dto?: OrderDto | null): void => {
  if (!dto) {
    return;
  }
};
